<template>
  <div class="d-flex flex-column align-items-center h-100">
    <div class="page-head">
      <div>
        <h3>Products in Stock</h3>
        <p class="page-head-sub">Airsuspension products currently on the shelves</p>
      </div>
    </div>
    <div v-if="loading" class="overlay d-flex justify-content-center align-items-center">
      <b-icon icon="arrow-clockwise" animation="spin" font-scale="4" variant="light"></b-icon>
    </div>
    <div v-else class="w-100">
      <b-table
        :key="'table-' + currentPage"
        striped
        hover
        responsive
        :items="products"
        :fields="fields"
      >
        <!-- Custom formatter for the link column -->
        <template #cell(link)="data">
          <a :href="data.value" target="_blank" class="">
            <b-icon icon="box-arrow-up-right"></b-icon>
          </a>
        </template>

        <template #cell(meta_data)="data">
          {{locationFromMeta(data.value)}}
        </template>

        <!-- Format price with currency symbol -->
        <template #cell(price)="data">
          {{ parseFloat(data.value).toLocaleString('en-US', {
          minimumFractionDigits: 0,
          maximumFractionDigits: 2,
        }) }}
        </template>
      </b-table>

      <div class="d-flex justify-content-center align-items-center mt-4 mb-3">
        <b-button
          variant="outline-secondary"
          size="sm"
          :disabled="currentPage <= 1"
          @click="currentPage > 1 && changePage(currentPage - 1)"
          class="mr-3"
        >
          <b-icon icon="chevron-left" font-scale="1"></b-icon>
        </b-button>

        <span class="mx-3 text-muted">Page {{ currentPage }}</span>

        <b-button
          variant="outline-secondary"
          size="sm"
          :disabled="products.length < perPage"
          @click="changePage(currentPage + 1)"
          class="ml-3"
        >
          <b-icon icon="chevron-right" font-scale="1"></b-icon>
        </b-button>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import fixed from '@/fixed';

export default {
  name: 'ProductsList',
  data() {
    return {
      loading: false,
      currentPage: 1,
      perPage: 50,
      hasMorePages: true,
      products: [],
      fields: [
        {
          key: 'name',
          label: 'Product Name',
          tdClass: 'text-left',
          thClass: 'text-left',
        },
        {
          key: 'sku',
          label: 'SKU',
          tdClass: 'text-center',
          thClass: 'text-center',
        },
        {
          key: 'price',
          label: 'Price',
          tdClass: 'text-right',
          thClass: 'text-right',
        },
        {
          key: 'qtt',
          label: 'Count',
          tdClass: 'text-center',
          thClass: 'text-center',
        },
        {
          key: 'meta_data',
          label: 'Location',
          tdClass: 'text-center',
          thClass: 'text-center',
        },
        {
          key: 'link',
          label: 'Link',
          tdClass: 'text-center',
          thClass: 'text-center',
        },
      ],
    };
  },
  mounted() {
    this.getProducts();
  },
  methods: {
    async getProducts() {
      this.loading = true;
      try {
        const { data } = await axios.get(
          `${fixed.API_URL}/admin/as-products`,
          {
            withCredentials: true,
            params: {
              stockStatus: 'instock',
              page: this.currentPage,
              perPage: this.perPage,
            },
          },
        );

        this.products = data.map((item) => ({
          name: item.name,
          link: item.permalink,
          sku: item.sku,
          price: item.price,
          qtt: item.stock_quantity,
          meta_data: item.meta_data,
        }));
      } catch (err) {
        this.$toast.error('error getting products');
      }
      this.loading = false;
    },
    locationFromMeta(meta) {
      if (!meta) return '';

      const locationMeta = meta.find((m) => m.key === '_location');
      return locationMeta ? locationMeta.value : '';
    },
    changePage(page) {
      this.currentPage = page;
      this.getProducts();
      window.scrollTo(0, 0);
    },
  },
};
</script>

<style scoped>
</style>
